// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "selectedPassenger__deleteButton-3ELXl";
var _4 = "passenger-KOPlp";
export { _1 as "__esModule", _2 as "mobile", _3 as "selectedPassenger__deleteButton", _4 as "passenger" }
export default { "__esModule": _1, "mobile": _2, "selectedPassenger__deleteButton": _3, "passenger": _4 }
